import React, { useEffect, useMemo, useState } from 'react';
import api from '../../services/api';
import { buildEventQueryParams } from '../../utils/urlParamsUtils';

const getQrTokenFromQuery = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('token');
};

const TokenRoute = () => {
  const token = useMemo(() => getQrTokenFromQuery(), []);
  const [status, setStatus] = useState({ state: 'loading', message: '' });

  useEffect(() => {
    if (!token) {
      setStatus({
        state: 'error',
        message: 'Missing QR token. Please scan the QR code again.',
      });
      return;
    }

    let cancelled = false;

    const run = async () => {
      try {
        const response = await api.get('/media/verify-token-json', {
          params: { token },
        });

        const payload = response?.data || {};
        const { eventId, eventCode, mainEventPhoto, token: eventToken } = payload;

        if (!eventId || !eventCode || !eventToken) {
          throw new Error('Invalid response from server');
        }

        const qp = buildEventQueryParams({
          eventId,
          eventCode,
          mainEventPhoto,
          token: eventToken,
        }).toString();

        if (cancelled) return;

        setStatus({ state: 'success', message: '' });
        // Navigate to the normal guest app entrypoint with event loaded
        window.location.replace(`/?${qp}`);
      } catch (err) {
        if (cancelled) return;
        const httpStatus = err?.response?.status;
        if (httpStatus === 401) {
          setStatus({
            state: 'error',
            message: 'Invalid or expired QR code. Please ask the staff for a new QR.',
          });
          return;
        }
        setStatus({
          state: 'error',
          message: 'Could not verify QR code. Please try again.',
        });
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 420, background: 'white', borderRadius: 16, padding: 20, boxShadow: '0 8px 24px rgba(0,0,0,0.12)' }}>
        <h2 style={{ margin: 0, marginBottom: 10, fontSize: 18, color: '#2c3e50' }}>
          {status.state === 'loading' ? 'Verifying QR…' : status.state === 'success' ? 'Redirecting…' : 'QR Error'}
        </h2>
        <p style={{ margin: 0, color: '#555', fontSize: 14, lineHeight: 1.5 }}>
          {status.state === 'loading'
            ? 'Please wait a moment.'
            : status.state === 'success'
              ? 'Taking you to the event.'
              : status.message}
        </p>
      </div>
    </div>
  );
};

export default TokenRoute;

